/* Hello Honeypie: auto-advancing carousels with arrows */
(function () {
  function initCarousel(root) {
    if (root.dataset.hhpReady) return;
    root.dataset.hhpReady = '1';
    var viewport = root.querySelector('.hhp-carousel__viewport');
    var prev = root.querySelector('.hhp-carousel__arrow--prev');
    var next = root.querySelector('.hhp-carousel__arrow--next');
    if (!viewport) return;
    var delay = parseInt(root.dataset.autoplay || '0', 10);
    var paused = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var item = viewport.querySelector('.hhp-carousel__item');
      if (!item) return viewport.clientWidth;
      var track = item.parentElement;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function atEnd() { return viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4; }
    function goNext() {
      if (atEnd()) viewport.scrollTo({ left: 0, behavior: 'smooth' });
      else viewport.scrollBy({ left: step(), behavior: 'smooth' });
    }
    function goPrev() {
      if (viewport.scrollLeft <= 4) viewport.scrollTo({ left: viewport.scrollWidth, behavior: 'smooth' });
      else viewport.scrollBy({ left: -step(), behavior: 'smooth' });
    }
    if (next) next.addEventListener('click', goNext);
    if (prev) prev.addEventListener('click', goPrev);

    ['mouseenter', 'focusin', 'touchstart'].forEach(function (e) { root.addEventListener(e, function () { paused = true; }, { passive: true }); });
    ['mouseleave', 'focusout'].forEach(function (e) { root.addEventListener(e, function () { paused = false; }); });
    root.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 4000); }, { passive: true });

    if (delay > 0 && !reduce) {
      setInterval(function () {
        if (!paused && document.visibilityState === 'visible') goNext();
      }, delay);
    }
  }
  function initAll() { document.querySelectorAll('[data-hhp-carousel]').forEach(initCarousel); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
